import { proxy } from 'valtio';

import { SelectionItem } from '@diagram/state/selection';
import { SidebarTab, SidebarType } from '@diagram/state/sidebar';

export type SidebarHistoryEntry = {
    type: SidebarType;
    tab: SidebarTab | null;
    selection: SelectionItem[];
};

const state = proxy<{
    entries: SidebarHistoryEntry[];
    index: number;
}>({
    entries: [],
    index: -1,
});

export { state };
